var _g, _circle, _circle2, _path, _path2, _path3, _circle3, _circle4, _circle5, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareOpinion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_392_80778)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "#3E74B5",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 39,
    fill: "#2B67AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6858 44.2581C63.6858 47.6822 61.7284 50.9041 58.3176 53.32C54.9099 55.7338 50.137 57.2661 44.8068 57.2661C39.4765 57.2661 34.7036 55.7338 31.2959 53.32C27.8852 50.9041 25.9277 47.6822 25.9277 44.2581C25.9277 40.834 27.8852 37.6121 31.2959 35.1961C34.7036 32.7823 39.4765 31.25 44.8068 31.25C50.137 31.25 54.9099 32.7823 58.3176 35.1961C61.7284 37.6121 63.6858 40.834 63.6858 44.2581Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6839 55.335C24.8606 56.2593 23 56.8225 23 56.8225C23 56.8225 26.171 58.0448 28.3677 57.5662C30.3758 57.1287 33.0645 55.335 33.0645 55.335L29.7097 53.1038L27.0258 50.1289C27.0258 50.1289 26.6753 54.222 25.6839 55.335Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.452 46.3555L37.2584 52.6458L29.2907 56.0006L27.6133 54.3232L28.452 46.3555Z",
    fill: "#2B67AF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.9352,
    cy: 44.2575,
    r: 1.67742,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.6774,
    cy: 44.2575,
    r: 1.67742,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.8063,
    cy: 44.2575,
    r: 1.67742,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2495 65.9806C50.2495 70.5244 55.142 74.7113 61.8821 74.7113C68.6221 74.7113 73.5146 70.5244 73.5146 65.9806C73.5146 61.4369 68.6221 57.25 61.8821 57.25C55.142 57.25 50.2495 61.4369 50.2495 65.9806Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1212 73.7361C74.6481 74.3831 75.8389 74.7773 75.8389 74.7773C75.8389 74.7773 73.8094 75.6329 72.4035 75.2979C71.1183 74.9917 69.3976 73.7361 69.3976 73.7361L71.5447 72.1742L73.2624 70.0918C73.2624 70.0918 73.4867 72.957 74.1212 73.7361Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 67.5L67.5 72L72.5 74V73L71.5 67.5Z",
    fill: "#2B67AF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.07355,
    cy: 1.17419,
    rx: 1.07355,
    ry: 1.17419,
    transform: "matrix(-1 0 0 1 66.7139 64.8066)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.07355,
    cy: 1.17419,
    rx: 1.07355,
    ry: 1.17419,
    transform: "matrix(-1 0 0 1 59.1992 64.8066)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.07355,
    cy: 1.17419,
    rx: 1.07355,
    ry: 1.17419,
    transform: "matrix(-1 0 0 1 62.957 64.8066)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_392_80778",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_392_80778"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_392_80778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_392_80778",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur_392_80778"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOpinion);
export default __webpack_public_path__ + "static/media/ShareOpinion.845b6905a44a29445c0303715d9d4c2b.svg";
export { ForwardRef as ReactComponent };